module.exports = __webpack_public_path__ + "img/background08.caaa794f.jpg";